export * from './Privacy';
export { Privacy as default } from './Privacy';
